var exports = {
  "z": "x93eb46d8--e68f5b--root",
};

module.exports = exports;
